<div class="header-notifications-bell">
    <button
        #bellTrigger
        type="button"
        mat-icon-button
        class="header-notifications-bell__trigger"
        [class.header-notifications-bell__trigger--unread]="unreadCount > 0"
        [matTooltip]="'menu.header.notifications' | transloco"
        [attr.aria-expanded]="isPanelOpen"
        aria-haspopup="dialog"
        (click)="togglePanel()"
    >
        <mat-icon class="header-notifications-bell__icon">notifications</mat-icon>

        @if (unreadCount > 0) {
            <span class="header-notifications-bell__badge" aria-hidden="true">{{ badgeLabel }}</span>
        }
    </button>
</div>
